export const enServicesDropdown = {
  web_development: {
    title: "Web Development",
    description: "Custom website development with modern technologies and responsive design."
  },
  mobile_app: {
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications for iOS and Android."
  },
  digital_transformation: {
    title: "Digital Transformation Consulting",
    description: "Modernize your business processes with digital solutions and automation."
  },
  seo: {
    title: "SEO Services",
    description: "Improve your search engine rankings and online visibility."
  },
  social_media: {
    title: "Social Media Management",
    description: "Build and maintain your brand presence across social platforms."
  },
  graphic_design: {
    title: "Graphic Design",
    description: "Creative visual solutions for your brand identity and marketing materials."
  },
  cloud_devops: {
    title: "Cloud & DevOps",
    description: "Cloud infrastructure and continuous integration/delivery solutions."
  },
  cybersecurity: {
    title: "Cyber Security",
    description: "Comprehensive protection for your digital assets and infrastructure."
  },
  it_support: {
    title: "IT Support",
    description: "Reliable technical support and maintenance services for your business."
  }
};

export const frServicesDropdown = {
  web_development: {
    title: "Développement Web",
    description: "Développement de sites web sur mesure avec des technologies modernes et un design réactif."
  },
  mobile_app: {
    title: "Développement d'Applications Mobiles",
    description: "Applications mobiles natives et multiplateformes pour iOS et Android."
  },
  digital_transformation: {
    title: "Consultation en Transformation Numérique",
    description: "Modernisez vos processus métier avec des solutions numériques et de l'automatisation."
  },
  seo: {
    title: "Services SEO",
    description: "Améliorez votre classement dans les moteurs de recherche et votre visibilité en ligne."
  },
  social_media: {
    title: "Gestion des Réseaux Sociaux",
    description: "Construisez et maintenez votre présence de marque sur les plateformes sociales."
  },
  graphic_design: {
    title: "Design Graphique",
    description: "Solutions visuelles créatives pour l'identité de votre marque et vos supports marketing."
  },
  cloud_devops: {
    title: "Cloud & DevOps",
    description: "Infrastructure cloud et solutions d'intégration/livraison continue."
  },
  cybersecurity: {
    title: "Cybersécurité",
    description: "Protection complète de vos actifs numériques et de votre infrastructure."
  },
  it_support: {
    title: "Support IT",
    description: "Support technique fiable et services de maintenance pour votre entreprise."
  }
};

export const nlServicesDropdown = {
  web_development: {
    title: "Webontwikkeling",
    description: "Maatwerk websiteontwikkeling met moderne technologieën en responsief ontwerp."
  },
  mobile_app: {
    title: "Mobiele App Ontwikkeling",
    description: "Native en cross-platform mobiele applicaties voor iOS en Android."
  },
  digital_transformation: {
    title: "Digitale Transformatie Advies",
    description: "Moderniseer uw bedrijfsprocessen met digitale oplossingen en automatisering."
  },
  seo: {
    title: "SEO Diensten",
    description: "Verbeter uw zoekmachineresultaten en online zichtbaarheid."
  },
  social_media: {
    title: "Social Media Beheer",
    description: "Bouw en onderhoud uw merkpresentatie op sociale platforms."
  },
  graphic_design: {
    title: "Grafisch Ontwerp",
    description: "Creatieve visuele oplossingen voor uw merkidentiteit en marketingmateriaal."
  },
  cloud_devops: {
    title: "Cloud & DevOps",
    description: "Cloudinfrastructuur en oplossingen voor continue integratie/levering."
  },
  cybersecurity: {
    title: "Cyberbeveiliging",
    description: "Uitgebreide bescherming voor uw digitale bezittingen en infrastructuur."
  },
  it_support: {
    title: "IT Ondersteuning",
    description: "Betrouwbare technische ondersteuning en onderhoudsdiensten voor uw bedrijf."
  }
};

export const deServicesDropdown = {
  web_development: {
    title: "Webentwicklung",
    description: "Individuelle Website-Entwicklung mit modernen Technologien und responsivem Design."
  },
  mobile_app: {
    title: "Mobile App Entwicklung",
    description: "Native und plattformübergreifende mobile Anwendungen für iOS und Android."
  },
  digital_transformation: {
    title: "Beratung zur digitalen Transformation",
    description: "Modernisieren Sie Ihre Geschäftsprozesse mit digitalen Lösungen und Automatisierung."
  },
  seo: {
    title: "SEO-Dienste",
    description: "Verbessern Sie Ihr Suchmaschinenranking und Ihre Online-Sichtbarkeit."
  },
  social_media: {
    title: "Social Media Management",
    description: "Bauen und pflegen Sie Ihre Markenpräsenz auf sozialen Plattformen."
  },
  graphic_design: {
    title: "Grafikdesign",
    description: "Kreative visuelle Lösungen für Ihre Markenidentität und Marketingmaterialien."
  },
  cloud_devops: {
    title: "Cloud & DevOps",
    description: "Cloud-Infrastruktur und Lösungen für kontinuierliche Integration/Lieferung."
  },
  cybersecurity: {
    title: "Cyber-Sicherheit",
    description: "Umfassender Schutz für Ihre digitalen Vermögenswerte und Infrastruktur."
  },
  it_support: {
    title: "IT-Support",
    description: "Zuverlässiger technischer Support und Wartungsdienste für Ihr Unternehmen."
  }
};